module.exports = __webpack_public_path__ + "img/line.97145afa.png";